import { action } from "typesafe-actions";
import { ILead } from "./leads.types";
import { IDate } from "../../components/Table/hooks/useDateFilter";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  convertLoaderCompleted,
  convertLoaderProgress,
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { IQueryParams } from "../common/common.types";
import { getSearchQuery } from "../common/helpers";
import { makeApiCall } from "../../helpers/postRequest";
import { endPoints } from "../../constants/endPoints";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";

export const FETCH_LEADS_LIST_PROGRESS = "FETCH_LEADS_LIST_PROGRESS";
export const FETCH_LEADS_LIST_SUCCESS = "FETCH_LEADS_LIST_SUCCESS";
export const FETCH_LEADS_LIST_FAILED = "FETCH_LEADS_LIST_FAILED";

export const fetchLeadsListProgress = () => action(FETCH_LEADS_LIST_PROGRESS);
export const fetchLeadsListSuccess = (list: ILead[], totalRecords: number) =>
  action(FETCH_LEADS_LIST_SUCCESS, { list, totalRecords });
export const fetchLeadsListFailed = () => action(FETCH_LEADS_LIST_FAILED);

export const fetchLeadsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    searchType:string[],
    values: string,
    isConvertStatus?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      // const searchQuery = getSearchQuery(queryParams);
      dispatch(fetchLeadsListProgress());
      dispatch(saveLoaderProgress());

      console.log(searchType, "searchType..");

      console.log(searchValue, "searchValue..");
      
      

      let url = "";
      if (status !== "-1") {
        url += `&status=${status}`;
      }
      if (searchValue.length > 0) {
        url += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
     
      if (searchType.length > 0 && values) {
        // const searchTypeStr = searchType.join(","); 
        url += `&column=${searchType}&value=${JSON.stringify(values)}`;
      }

      let finalUrl =
        `/leads/get-leads?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` +
        url;
      const res = await api.get(finalUrl);
      const data: ILead[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchLeadsListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchLeadsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_LEAD_PROGRESS = "FETCH_LEAD_PROGRESS";
export const FETCH_LEAD_SUCCESS = "FETCH_LEAD_SUCCESS";
export const FETCH_LEAD_FAILED = "FETCH_LEAD_FAILED";

export const fetchLeadProgress = () => action(FETCH_LEAD_PROGRESS);
export const fetchLeadSuccess = (lead: ILead) =>
  action(FETCH_LEAD_SUCCESS, { lead });
export const fetchLeadFailed = (errorMessage: string) =>
  action(FETCH_LEAD_FAILED, { errorMessage });

export const fetchLeadAsync =
  (leadId: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchLeadProgress());
      dispatch(saveLoaderProgress());
      const res = await api.get(`/leads/get-leads?leads_uuid=${leadId}`);
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchLeadSuccess(data[0]));
      } else {
        dispatch(
          fetchLeadFailed(
            "Unfortunately, there are no records available at the moment."
          )
        );
      }
    } catch (err: any) {
      dispatch(fetchLeadFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const upsertLeadAsync =
  (
    existingLead: ILead,
    initialLead: ILead,

    isUpdate: boolean,
    isopportunity: boolean,
    onCallBack: (isSuccess?: boolean, data?: ILead) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const {
        create_ts,
        insert_ts,
        modified_by_name,
        modified_by_uuid,
        created_by_name,
        created_by_uuid,
        leads_unique_id,
        assigned_to_code,
        assigned_to_name,
        assigned_to_id,
        session_uuid,
        
        ...rest
      } = existingLead;

      const res = await makeApiCall(
        {
          url: endPoints.leads.upsertLead,
          method: "POST",
          automation: {
            primaryFieldName: "lead_id",
            isUpdate: isUpdate,
          },
        },
        initialLead,
        rest
      );
      dispatch(
        showMessage({
          type: "success",
          message: "Lead is saved successfully",
          displayAs: "snackbar",
        })
      );
      const data = res.data.data;
      onCallBack(true, data);
    } catch (err: any) {
      onCallBack(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const convertToOpportunityAsync =
  (
    leadUUID: string,
    onCallBack: (isSuccess?: boolean, data?: ILead) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    dispatch(convertLoaderProgress());
    try {
      const res = await api.post("/leads/convert-leads-into-opportunity", {
        leads_uuid: leadUUID,
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Successfully converted to opportunity!",
          displayAs: "snackbar",
        })
      );
      const data = res.data.data;
      onCallBack(true, data);
    } catch (err: any) {
      onCallBack(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(convertLoaderCompleted());
    }
  };

export const CLEAR_LEAD_STATE = "CLEAR_LEAD_STATE";
export const CLEAR_LEAD = "CLEAR_LEAD";

export const clearLeadsState = () => action(CLEAR_LEAD_STATE);
export const clearLead = () => action(CLEAR_LEAD);
